import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'whatsapp-widget',
    standalone: true,
    imports: [CommonModule],
    template: `
        <a href="https://wa.me/5491139030084" 
           target="_blank" 
           rel="noopener noreferrer"
           class="whatsapp-float flex align-items-center justify-content-center border-circle shadow-6 z-5 transition-all duration-300 hover:scale-110"
           aria-label="Contactar por WhatsApp">
            
            <i class="pi pi-whatsapp"></i>
            
            <span class="absolute top-0 right-0 flex h-1rem w-1rem">
                <span class="animate-ping absolute inline-flex h-full w-full border-circle bg-black-alpha-50 opacity-75"></span>
                <span class="relative inline-flex border-circle h-1rem w-1rem bg-black-alpha-90 border-1 border-white"></span>
            </span>
        </a>
    `,
    styles: [`
        .whatsapp-float {
            position: fixed;
            bottom: 2rem;
            right: 2rem;
            width: 4rem;
            height: 4rem;
            background-color: #ffffff;
            color: #00FF00;
            text-decoration: none;
        }

        .whatsapp-float i {
            font-size: 2.2rem;
        }

        /* Animación nativa de Tailwind/PrimeFlex para el "ping" de atención */
        @keyframes ping {
            75%, 100% {
                transform: scale(2);
                opacity: 0;
            }
        }
        .animate-ping {
            animation: ping 1.5s cubic-bezier(0, 0, 0.2, 1) infinite;
        }

        /* Ajustes Mobile: Un poco más sutil para no tapar contenido clave */
        @media (max-width: 768px) {
            .whatsapp-float {
                bottom: 1.5rem;
                right: 1.5rem;
                width: 3.5rem;
                height: 3.5rem;
            }
            .whatsapp-float i {
                font-size: 1.8rem;
            }
        }
    `]
})
export class WhatsappWidget {}